module.exports = {
    // basic
    'reset-password': 'restablecer la contraseña',

    // raw
    'reset-password-success': 'La contraseña se restableció correctamente.',
    'reset-password-fail': `
        <p>
            No pudimos completar su solicitud.
        </p>
        <p>
            Por favor comuníquese con los Operadoers de WellDrive para obtener ayuda.
        </p>
        <p>
            <a href="#login" class="forgot-password-link">Volver a la página de inicio de sesión</a>
        </p>
    `,
    'password-empty': 'Debes ingresar tu contraseña actual.',
    'new-password-empty': 'Debes ingresar una nueva contraseña.',
    'password-confirmation-mismatch': 'Su contraseña y confirmación de contraseña deben ser las mismas',

    // template
};
